import type { Block, StreamingBlock } from "@storytell/streaming";

export const copyBlockDebugInfoToClipboard = async (block: StreamingBlock) => {
  try {
    const jsonString = JSON.stringify(block, null, 2);
    await navigator.clipboard.writeText(jsonString);
  } catch (error) {
    // Silently handle clipboard errors
  }
};
